import React from 'react'
import { useLocation } from 'react-router-dom'

import Items from 'containers/inventory/shared/items'
import { useAccountRoutes } from 'containers/routes'

const ELBLoadBalancers = ({ loadBalancers }) => {
  const { search } = useLocation()
  const routes = useAccountRoutes()

  const formatted = loadBalancers?.map(loadBalancer => {
    return {
      id: loadBalancer.loadBalancerArn,
      title: loadBalancer.loadBalancerName,
      url: { pathname: routes.inventory.resource.url({ resourceId: loadBalancer.id }), search },
      description: loadBalancer.loadBalancerArn
    }
  })
  return (
    <Items items={formatted} />
  )
}

export default ELBLoadBalancers
